import { Select } from "antd";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import debounce from "lodash/debounce";
import toast from "react-hot-toast";
import { BiSolidTrash } from "react-icons/bi";
import { IoCloseSharp } from "react-icons/io5";
import { useSelector } from "react-redux";
import { Col, Label, Modal, ModalBody, Row } from "reactstrap";
import { getAllSaleOrders } from "../../api/pagination";
import { processPayment } from "../../api/payment.api";
import GeneralButton from "../button/GeneralButton";
import FormInput from "../formInput/FormInput";
const PayForOrderModal = ({ modal, toggle, selectedData }) => {
  const [totalAmount, setTotalAmount] = useState(0);
  const { sale_orders } = useSelector((state) => state.orders);
  const [searchOrders, setSearchOrders] = useState([]);
  const [selectedItemData, setSelectedItemData] = useState(selectedData ?? []);
  const [loading, setLoading] = useState(false);
  const [cardDetails, setCardDetails] = useState({
    cardNumber: "",
    cardHolderName: "",
    cvcNumber: "",
    pickMonthYear: null,
  });
  useEffect(() => {
    setSelectedItemData(
      selectedData?.filter((i) => i?.status !== "Processed") ?? []
    );
  }, [selectedData]);
  useEffect(() => {
    onSelectAddAmount();
  }, [selectedItemData]);
  //select order
  const onSelectOrder = (index, item) => {
    const selected_product =
      searchOrders?.length > 0
        ? searchOrders?.find((i) => i?.id === item?.label)
        : sale_orders?.find((i) => i?.id === item?.label);
    if (!selected_product) {
      toast.error("Selected product not found.");
      return;
    }
    if (selectedItemData?.find((i) => i?.id === selected_product?.id)) {
      toast.error("You cannot select duplicate orders.");
    } else {
      if (selected_product?.status !== "Processed") {
        setSelectedItemData([...selectedItemData, selected_product]);
      }
    }
  };
  //total amount of all items
  const onSelectAddAmount = () => {
    var initialValue = 0;
    let getListForAmount = [...selectedItemData];
    let newTotalAmount = getListForAmount?.map(
      (item) =>
        (initialValue = parseFloat(item?.total) + parseFloat(initialValue))
    );
    setTotalAmount(initialValue);
  };
  //remove item from list
  const onPressRemoveItemFromList = (selectedItem) => {
    let selected_item = [...selectedItemData];
    let new_selected_item_list = selected_item?.filter(
      (i) => i?.id !== selectedItem?.id
    );
    setSelectedItemData(new_selected_item_list);
  };
  const payForOrders = async () => {
    const { pickMonthYear, cardNumber, cvcNumber } = cardDetails;
    const order_ids = selectedItemData?.map((i) => i?._id);
    let formateYear = moment(pickMonthYear).format("YY");
    let formateMonth = moment(pickMonthYear).format("MM");
    let formateCardNumber = cardNumber.replace(/\s/g, "");
    const pay_forOrder_data = {
      orderIds: order_ids,
      cardNumber: formateCardNumber,
      cardCode: cvcNumber,
      expiryDate: `${formateMonth}/${formateYear}`,
      amount: totalAmount?.toFixed(2),
    };
    setLoading(true);
    await processPayment(pay_forOrder_data, (res) => {
      if (res?.status === 200) {
        toast.success(res.data.message);
        setLoading(false);
        toggle();
      } else {
        toast.error(res.message || res.details || "Payment processing failed");
        setLoading(false);
        toggle();
      }
    });
  };
  const fetchOrdersDebounced = useCallback(
    debounce((searchText) => {
      getAllSaleOrders("", "", false, "", "", 1, 50, searchText, "desc", (res) => {
        if (res) {
          setSearchOrders(res?.data?.data);
        }
      });
    }, 500),
    []
  );

  const handleOrderSearch = (searchText) => {
    fetchOrdersDebounced(searchText);
  };
  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      centered
      size="lg"
      onClosed={() => {
        setCardDetails({});
        setSelectedItemData([]);
      }}
    >
      <ModalBody className="p-3">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h4 className="primary-color">Add Payment</h4>
          <IoCloseSharp size={"30"} onClick={toggle} />
        </div>
        <Row className="mb-2">
          <div className="d-flex justify-content-end align-items-center fs-18 fw-bold">
            <span className="text-primary"> Total Amount :</span> $
            {totalAmount ? totalAmount?.toFixed(2) : 0}
          </div>
          <Col>
            {selectedItemData.length > 0 && (
              <Col>
                <table className="table table-striped table-bordered align-middle mt-2 shadow-sm">
                  <thead className="table-primary">
                    <tr>
                      <th className="fw-bold">Order #</th>
                      <th className="fw-bold">Total ($)</th>
                      <th className="fw-bold text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedItemData.map((i) => (
                      <tr key={i.id}>
                        <td>{i?.id}</td>
                        <td>${parseFloat(i?.total).toFixed(2)}</td>
                        <td className="text-center">
                          <BiSolidTrash
                            size={20}
                            className="text-danger pointer"
                            onClick={() => onPressRemoveItemFromList(i)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Col>
            )}
          </Col>
        </Row>
        <Row className="mb-2">
          <Col md={3}>
            <FormInput
              type={"text"}
              label={"Card Holder"}
              placeholder={"jason"}
              className={`sales__inputCustomer border border-1`}
              value={cardDetails.cardHolderName}
              handleChange={(e) =>
                setCardDetails({
                  ...cardDetails,
                  cardHolderName: e.target.value,
                })
              }
            />
          </Col>
          <Col md={3}>
            <FormInput
              type={"number"}
              label={"Card Number #"}
              placeholder={"00"}
              className={`sales__inputCustomer border border-1`}
              value={cardDetails.cardNumber}
              handleChange={(e) =>
                setCardDetails({
                  ...cardDetails,
                  cardNumber: e.target.value,
                })
              }
            />
          </Col>
          <Col md={3}>
            <FormInput
              type={"number"}
              label={"CVC"}
              placeholder={"00"}
              className={`sales__inputCustomer border border-1`}
              value={cardDetails.cvcNumber}
              handleChange={(e) =>
                setCardDetails({
                  ...cardDetails,
                  cvcNumber: e.target.value,
                })
              }
            />
          </Col>
          <Col md={3}>
            <Label className="fw-bold">Expiry Date</Label>
            <FormInput
              label={"Expire Date"}
              fontWeight={"500"}
              monthYear
              handleChange={(e) => {
                setCardDetails({
                  ...cardDetails,
                  pickMonthYear: e,
                });
              }}
              state={cardDetails.pickMonthYear}
            />
          </Col>
          <div className="d-flex justify-content-between">
            <div>
              <Select
                showSearch
                style={{ width: 200 }}
                placeholder="Search to Select"
                optionFilterProp="label"
                options={
                  searchOrders?.length > 0
                    ? searchOrders?.map((i) => ({
                        value: i?._id,
                        label: i?.id,
                      }))
                    : sale_orders?.map((i) => ({
                        value: i?._id,
                        label: i?.id,
                      }))
                }
                onSelect={onSelectOrder}
                onSearch={handleOrderSearch}
              />
            </div>
            <div>
              <GeneralButton
                title={"Cancel"}
                className={"white-button mx-2"}
                width={"180px"}
                handleClick={toggle}
              />
              <GeneralButton
                title={"Authorize Payment"}
                className={"blue-button"}
                width={"180px"}
                handleClick={payForOrders}
                loading={loading}
                disabled={loading}
              />
            </div>
          </div>
        </Row>
      </ModalBody>
    </Modal>
  );
};
export default PayForOrderModal;
